import { createFileRoute, Navigate } from "@tanstack/react-router"

const AgentIndexPage = () => {
    return <Navigate to="/agent/policy" />
}

export const Route = createFileRoute("/_authenticated/agent/")({
    component: AgentIndexPage,
})
